import {api2Endpoint} from 'app/config/apiConfig'
import {postData} from 'app/hooks/api/usePostData'
import {queryDefaults} from 'app/react-query'
import {useQuery} from 'react-query'

export function useGetUniversities() {
  return useQuery({
    queryKey: ['innovations_result_universities'],
    queryFn: async () => {
      const jsonObj = {
        select: {id: '', name: ''},
        filter: {innovations: {'id@': ''}},
        page: 1,
        per_page: 1000,
      }
      const route = api2Endpoint('graph/business')
      const retval = await postData<any>(route, jsonObj, 'post')
      if (retval?.records?.length) {
        retval.records.sort((a: any, b: any) => a.name.localeCompare(b.name))
      }
      return retval
    },
    cacheTime: queryDefaults.cacheTime,
    staleTime: queryDefaults.staleTime,
    retry: false,
  })
}
